// extracted by mini-css-extract-plugin
export default {"donutChart":"DonutChart_donutChart__CNcHA","chartImage":"DonutChart_chartImage__rWWa1","legend":"DonutChart_legend__xxBwT"};